import { hasPermission, type Permission } from '@repo/contracts';

import { APP_PERMISSIONS } from '@/constants/app-permissions';

export const hasAppAccess = (permissions: readonly Permission[]): boolean =>
  APP_PERMISSIONS.some((permission) => hasPermission(permissions, [permission]));
